import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { projectsHeader, personalProjects } from "../../portfolio.js";
import { translate } from "../../i18n";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    const embedded = this.props.embedded;
    const Root = embedded ? "section" : "div";
    const Content = embedded ? "div" : "main";

    return (
      <Root
        id={embedded ? "projects" : undefined}
        className={`projects-main site-scroll-section${
          embedded ? " embedded-section" : ""
        }`}
      >
        {!embedded && <Header theme={theme} />}
        <Content className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
              </div>
            </div>
          </Fade>
          <div className="personal-projects-grid">
            {personalProjects.map((project, index) => {
              const Card = project.url ? "a" : "article";
              return (
                <Fade
                  bottom
                  duration={700}
                  distance="28px"
                  delay={index * 100}
                  key={project.name}
                >
                  <Card
                    className="personal-project-card"
                    {...(project.url
                      ? {
                          href: project.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                        }
                      : {})}
                  >
                    <div className="personal-project-visual">
                      {project.image ? (
                        <img
                          className="personal-project-image"
                          src={project.image}
                          alt=""
                          width="80"
                          height="80"
                          loading="lazy"
                        />
                      ) : (
                        <span
                          className="iconify personal-project-icon"
                          data-icon={project.icon}
                          aria-hidden="true"
                        />
                      )}
                      <span
                        className="personal-project-arrow"
                        aria-hidden="true"
                      >
                        ↗
                      </span>
                    </div>
                    <h2>{project.name}</h2>
                    {project.handle && (
                      <span className="project-link-pending" dir="ltr">
                        {project.handle}
                      </span>
                    )}
                    {!project.url && (
                      <span className="project-link-pending">
                        {translate("Link coming soon")}
                      </span>
                    )}
                    {project.url && (
                      <span className="personal-project-action">
                        {translate("Open on Telegram")}{" "}
                        <span aria-hidden="true">↗</span>
                      </span>
                    )}
                  </Card>
                </Fade>
              );
            })}
          </div>
        </Content>
        {!embedded && (
          <>
            <Footer theme={theme} onToggle={this.props.onToggle} />
            <TopButton theme={theme} />
          </>
        )}
      </Root>
    );
  }
}

export default Projects;
